import { AccountPayableFieldOption } from '../AccountPayable/AccountPayable.types';
import { AccountReceivableOrderColumn } from '../AccountReceivable/AccountReceivable.types';

export enum FinancialConfigurationUserColumn {
  code = 'domain.enums.financial_field_options.code',
  company = 'domain.enums.financial_field_options.company',
  debtorAndCreditor = 'domain.enums.financial_field_options.debtor_and_creditor',
  description = 'domain.enums.financial_field_options.description',
  documentType = 'domain.enums.financial_field_options.document_type',
  dueDate = 'domain.enums.financial_field_options.due_date',
  emissionDate = 'domain.enums.financial_field_options.emission_date',
  payDate = 'domain.enums.financial_field_options.pay_date',
  situation = 'domain.enums.financial_field_options.situation',
  value = 'domain.enums.financial_field_options.value',
  documentNumber = 'domain.enums.financial_field_options.document_number',
  installmentTag = 'domain.enums.financial_field_options.installment_tag',
  authorizationNumber = 'domain.enums.financial_field_options.authorization_number',
}

export interface FinancialConfiguration {
  column: FinancialConfigurationUserColumn;
  active: boolean;
}

export interface FinancialConfigurationRequest {
  configurations: FinancialConfiguration[];
}

export const convertColunsAccountPayableToProfile = {
  [AccountPayableFieldOption.code]: FinancialConfigurationUserColumn.code,
  [AccountPayableFieldOption.company]: FinancialConfigurationUserColumn.company,
  [AccountPayableFieldOption.creditor]:
    FinancialConfigurationUserColumn.debtorAndCreditor,
  [AccountPayableFieldOption.description]:
    FinancialConfigurationUserColumn.description,
  [AccountPayableFieldOption.documentType]:
    FinancialConfigurationUserColumn.documentType,
  [AccountPayableFieldOption.dueDate]: FinancialConfigurationUserColumn.dueDate,
  [AccountPayableFieldOption.emissionDate]:
    FinancialConfigurationUserColumn.emissionDate,
  [AccountPayableFieldOption.payDate]: FinancialConfigurationUserColumn.payDate,
  [AccountPayableFieldOption.value]: FinancialConfigurationUserColumn.value,
  [AccountPayableFieldOption.situation]:
    FinancialConfigurationUserColumn.situation,
  [AccountPayableFieldOption.documentNumber]:
    FinancialConfigurationUserColumn.documentNumber,
  [AccountPayableFieldOption.installmentTag]:
    FinancialConfigurationUserColumn.installmentTag,
  [AccountPayableFieldOption.authorizationNumber]:
    FinancialConfigurationUserColumn.authorizationNumber,
};

export const convertColunsAccountReceivableToProfile = {
  [AccountReceivableOrderColumn.code]: FinancialConfigurationUserColumn.code,
  [AccountReceivableOrderColumn.company]:
    FinancialConfigurationUserColumn.company,
  [AccountReceivableOrderColumn.debtor]:
    FinancialConfigurationUserColumn.debtorAndCreditor,
  [AccountReceivableOrderColumn.description]:
    FinancialConfigurationUserColumn.description,
  [AccountReceivableOrderColumn.documentType]:
    FinancialConfigurationUserColumn.documentType,
  [AccountReceivableOrderColumn.dueDate]:
    FinancialConfigurationUserColumn.dueDate,
  [AccountReceivableOrderColumn.payDate]:
    FinancialConfigurationUserColumn.payDate,
  [AccountReceivableOrderColumn.emissionDate]:
    FinancialConfigurationUserColumn.emissionDate,
  [AccountReceivableOrderColumn.value]: FinancialConfigurationUserColumn.value,
  [AccountReceivableOrderColumn.situation]:
    FinancialConfigurationUserColumn.situation,
  [AccountPayableFieldOption.documentNumber]:
    FinancialConfigurationUserColumn.documentNumber,
  [AccountPayableFieldOption.installmentTag]:
    FinancialConfigurationUserColumn.installmentTag,
  [AccountPayableFieldOption.authorizationNumber]:
    FinancialConfigurationUserColumn.authorizationNumber,
};
